'use client';

export const MoreHorizontal = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M6.48235 18.2667C5.85702 18.2667 5.32402 18.0441 4.88335 17.599C4.44268 17.1537 4.22235 16.6184 4.22235 15.9933C4.22235 15.3682 4.44491 14.8352 4.89002 14.3943C5.33513 13.9537 5.87035 13.7333 6.49568 13.7333C7.1208 13.7333 7.65368 13.9559 8.09435 14.401C8.53524 14.8463 8.75569 15.3816 8.75569 16.0067C8.75569 16.6318 8.53302 17.1648 8.08768 17.6057C7.64257 18.0463 7.10746 18.2667 6.48235 18.2667ZM15.9934 18.2667C15.3682 18.2667 14.8352 18.0441 14.3944 17.599C13.9537 17.1537 13.7334 16.6184 13.7334 15.9933C13.7334 15.3682 13.9559 14.8352 14.401 14.3943C14.8464 13.9537 15.3816 13.7333 16.0067 13.7333C16.6318 13.7333 17.1648 13.9559 17.6057 14.401C18.0464 14.8463 18.2667 15.3816 18.2667 16.0067C18.2667 16.6318 18.0441 17.1648 17.599 17.6057C17.1537 18.0463 16.6185 18.2667 15.9934 18.2667ZM25.5044 18.2667C24.8792 18.2667 24.3464 18.0441 23.9057 17.599C23.4648 17.1537 23.2444 16.6184 23.2444 15.9933C23.2444 15.3682 23.467 14.8352 23.9124 14.3943C24.3575 13.9537 24.8926 13.7333 25.5177 13.7333C26.143 13.7333 26.676 13.9559 27.1167 14.401C27.5574 14.8463 27.7777 15.3816 27.7777 16.0067C27.7777 16.6318 27.5551 17.1648 27.11 17.6057C26.6649 18.0463 26.1297 18.2667 25.5044 18.2667Z"
				fill="currentColor"
			/>
		</svg>
	);
};
